const state = {
  rooms: [],
  messages: {},
  status: true,
};

const mutations = {
  UPDATE_ROOMS(state, rooms) {
    state.rooms = rooms;
  },
  UPDATE_MESSAGES(state, messages) {
    state.messages = messages;
  },
  SEND_MESSAGE_SUCCESS(state) {
    state.status = true;
  },
  ADD_NEW_MESSAGE_TO_MESSAGES(state, message) {
    state.messages.messages.push(message);
  },
};

const getters = {
  getRooms: (state) => {
    return state.rooms;
  },
  getMessagesInfo: (state) => {
    return state.messages;
  },
  getReversedMessage: (state) => {
    if (
      state.messages.messages === null ||
      state.messages.messages === undefined
    )
      return null;
    return state.messages.messages.reverse();
  },
};

export default {
  state,
  mutations,
  getters,
};
